/**
 * Round timeline (Phase 7) - shown only once a report has more than one round, so the
 * reviewer can open any prior revision's markup/feedback and compare against the latest
 * resubmission. Hidden entirely for a first-round report (the common case).
 */
import type { ReportRow } from '../../reviewer/types';

interface RevisionSelectorProps {
  chain: ReportRow[];
  currentReportId: string;
  onSelect: (reportId: string) => void;
}

export function RevisionSelector({ chain, currentReportId, onSelect }: RevisionSelectorProps) {
  if (chain.length <= 1) return null;

  return (
    <div className="revision-selector" role="tablist" aria-label="Revision history">
      {chain.map((r) => (
        <button
          key={r.id}
          type="button"
          role="tab"
          aria-selected={r.id === currentReportId}
          className={`revision-pill${r.id === currentReportId ? ' revision-pill--active' : ''}`}
          onClick={() => onSelect(r.id)}
        >
          Revision {r.revisionNumber}
        </button>
      ))}
    </div>
  );
}
